import { Injectable } from '@angular/core';
import { MiaHttpService, ApiResponse } from '@mobileia/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Slider } from '@mobileia/slider';

@Injectable({
  providedIn: 'root'
})
export class SliderService extends MiaHttpService {

  protected _baseUrl = '';
  
  constructor(
    protected http: HttpClient,
  ) {
    super(http);
  }

  fetchActive(): Observable<ApiResponse<Array<Slider>>> {
    return this.postArray(environment.baseUrl + 'slider/list', { });
  }

  sumClick(sliderId: number): Observable<ApiResponse<Slider>> {
    return this.postObject(environment.baseUrl + 'slider/click', { id: sliderId });
  }
}